import { render, staticRenderFns } from "./ConteudoTermos.vue?vue&type=template&id=027c3d46"
import script from "./ConteudoTermos.vue?vue&type=script&lang=js"
export * from "./ConteudoTermos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports